module.exports = __webpack_public_path__ + "img/finalLogoMonochromo.7f1918ca.svg";